export const TAXEL_COLUMNS = 4;
export const TAXEL_ROWS = 7;
export const TAXEL_COUNT = TAXEL_COLUMNS * TAXEL_ROWS;
export const FINGER_COUNT = 2;

// Robotiq TSF-85 User Guide v1.0.0, Table 5: 0.011 N/count, specified for the
// sum of all taxels rather than a single one. A typical
// even-load figure; the response is hysteretic and non-linear (guide App. A/C).
export const NEWTONS_PER_COUNT = 0.011;
export const MILLIVOLTS_PER_DYNAMIC_COUNT = 1.024 / 32767;

/**
 * How often the fingertip emits a frame, written into it with the autosend
 * command. ~60 Hz. A driver-side fact like the other force sensors' poll
 * rates, not something an operator configures.
 */
export const DEFAULT_AUTOSEND_PERIOD_MS = 16;
